import { colors } from '../assets/colors';
const colorNames = colors.map(color => color.id);
const selColors = [];
let prohibColors = [];
export const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * colorNames.length);
    let randomColor = colorNames[randomIndex];
    while ((prohibColors.includes(randomColor) || selColors.includes(randomColor)) &&
        selColors.length + prohibColors.length !== colorNames.length) {
        const randomIndex = Math.floor(Math.random() * colorNames.length);
        randomColor = colorNames[randomIndex];
    }
    if (selColors.length + prohibColors.length === colorNames.length)
        return 'white';
    selColors.push(randomColor);
    const colorObj = colors.filter(color => color.id === randomColor)[0];
    if (colorObj.exclude) {
        const newProhibCol = colorObj.exclude.filter(color => !prohibColors.includes(color));
        prohibColors = [...prohibColors, ...newProhibCol];
    }
    return colorObj.id;
};
export function hexToRGB(h) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (h.length == 4) {
        r = '0x' + h[1] + h[1];
        g = '0x' + h[2] + h[2];
        b = '0x' + h[3] + h[3];
        // 6 digits
    }
    else if (h.length == 7) {
        r = '0x' + h[1] + h[2];
        g = '0x' + h[3] + h[4];
        b = '0x' + h[5] + h[6];
    }
    return [r / 255, g / 255, b / 255];
}
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}
export function rgbToHex(r, g, b) {
    return '#' + componentToHex(r * 255) + componentToHex(g * 255) + componentToHex(b * 255);
}
